/** @internal */
export enum PromptActionType {
    ALLOW = 'allow',
    DISMISS = 'dismiss',
}
